import { RefObject, useEffect } from 'react';

export function useClickOutside(ref: RefObject<Node>, callback: (event: MouseEvent) => void) {
    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (ref.current && !ref.current.contains(event.target as Node | null)) {
                callback(event);
            }
        }

        // Bind the event listener.
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, callback]);
}

export default useClickOutside;
